import * as yup from 'yup';

declare module 'yup' {
  interface Schema {
    /**
     * Imposta i meta per indicare se il campo è abilitato o disabilitato
     */
    layoutEnabled(input: boolean): this;
  }
}

function registerForSchema<T extends yup.Schema>(schema: (...arg: any[]) => T) {
  yup.addMethod<T>(schema, 'layoutEnabled', function (this: T, input: boolean) {
    return this.meta({ layoutEnabled: input });
  });
}

registerForSchema(yup.object);
registerForSchema(yup.array);
registerForSchema(yup.string);
registerForSchema(yup.number);
registerForSchema(yup.boolean);
registerForSchema(yup.date);
registerForSchema(yup.mixed);
